function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0v30h60V0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 15h30v15zv15H0zH0V0zV0h30z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0v30h60V0z",
  fill: "#012169"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0l60 30m0-30L0 30",
  stroke: "#fff",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0l60 30m0-30L0 30",
  clipPath: "url(#b)",
  stroke: "#C8102E",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 0v30M0 15h60",
  stroke: "#fff",
  strokeWidth: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 0v30M0 15h60",
  stroke: "#C8102E",
  strokeWidth: 6
}));

function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    viewBox: "0 0 60 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.497dfc4b.svg";
export { ForwardRef as ReactComponent };